import { render } from "./FormBDPComponent.vue?vue&type=template&id=4cb611e0"
import script from "./FormBDPComponent.vue?vue&type=script&lang=js"
export * from "./FormBDPComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__